<template>
    <div class="container">
        <div class="search">
            <el-form ref="form" inline :model="search" size="mini">
                <el-form-item>
                    <el-input v-model.trim="search.uid" @keyup.enter.native="Search" placeholder="用户uid"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select placeholder="状态" @change="Search" v-model="search.status" clearable>
                        <el-option :key="1" :value="1" label="待审核"></el-option>
                        <el-option :key="2" :value="2" label="审核成功"></el-option>
                        <el-option :key="3" :value="3" label="已过期"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="submitDate" type="daterange" range-separator="至" start-placeholder="最小申请时间"
                        end-placeholder="最大申请时间" size="mini" value-format="x">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass" @click="Search">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="clearCondition">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 列表 -->
        <el-table border :data="list" :empty-text="emptyText" size="mini">
            <el-table-column label="用户uid">
                <template v-slot="scope">
                    {{ scope.row.uid }}
                </template>
            </el-table-column>
            <el-table-column label="邮箱">
                <template v-slot="scope">
                    {{ scope.row.email }}
                </template>
            </el-table-column>
            <el-table-column label="保存天数" width="100">
                <template v-slot="scope">
                    {{ scope.row.file_time }}
                </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
                <template v-slot="scope">
                    {{
                        scope.row.status === 1
                            ? '待审核'
                            : scope.row.status === 2
                                ? '审核成功'
                                : scope.row.status === 3
                                    ? '已过期'
                                    : ''
                    }}
                </template>
            </el-table-column>
            <el-table-column label="过期时间" width="180">
                <template v-slot="scope">
                    {{
                        scope.row.expired_time
                            ? dayjs.unix(scope.row.expired_time).format('YYYY-MM-DD HH:mm:ss')
                            : ''
                    }}
                </template>
            </el-table-column>
            <el-table-column label="申请时间" width="180">
                <template v-slot="scope">
                    {{
                        scope.row.application_time
                            ? dayjs.unix(scope.row.application_time).format('YYYY-MM-DD HH:mm:ss')
                            : ''
                    }}
                </template>
            </el-table-column>
            <el-table-column label="审核通过时间" width="180">
                <template v-slot="scope">
                    {{ scope.row.approved_time ? dayjs.unix(scope.row.approved_time).format('YYYY-MM-DD HH:mm:ss') : '' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template v-slot="scope">
                    <div style="text-align: center;" v-if="scope.row.status === 1">
                        <el-button size="mini" type="success" @click="audit(scope.row.id)"
                            style="margin-bottom: 2px;">审核</el-button>
                        <!-- <el-button size="mini" type="danger" @click="cancelDelete(scope.row.uid)">取消删除</el-button> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total">
        </el-pagination>
    </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs'

export default {
    name: '',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            title: '',
            search: {
                page: 1,
                limit: 16,
                uid: '',
                status: '',
                min_application_time: '',
                max_application_time: ''
            },
            submitDate: '',
            list: [],
            total: 0,
            emptyText: '请按条件查询',
            dayjs: dayjs
        }
    },
    computed: {},
    watch: {},
    methods: {
        handleCurrentChange(val) {
            this.search.page = val
            this.Search()
        },
        Search() {
            let min_application_time = this.submitDate ? this.getTenTime(this.submitDate[0]) : ''
            let max_application_time = this.submitDate ? this.getTenTime(this.submitDate[1]) : ''
            this.api.UserApplicationList({
                ...this.search,
                min_application_time,
                max_application_time
            }).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.list
                    this.total = res.data.data.page_info.total
                    if (res.data.data.data?.length == 0 || !res.data.data.data) {
                        this.emptyText = 'No Data'
                    }
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        getTenTime(date) {
            return Math.round(date.getTime() / 1000).toString()
        },
        audit(id) {
            this.$confirm('是否审核该用户?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除请求
                this.api.UserApplicationHandle({
                    record_id: id
                }).then(res => {
                    if (res.data.code == 200) {
                        this.Search()
                        this.$message.success('审核成功')
                        return
                    }
                    this.$message.error('审核失败' + res.data.msg)
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消审核'
                })
            })
        },
        clearCondition() {
            this.reset()
            this.Search()
        },
        reset() {
            this.search = {
                ...this.search,
                page: 1,
                limit: 16,
                uid: '',
                status: '',
                min_application_time: '',
                max_application_time: ''
            }
            this.submitDate = ''
        },
    },
    filters: {},
    mounted() {
        this.Search()
    },
    created() {
    },

}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
